'use client';
import React from 'react';
import dynamic from 'next/dynamic';

interface CoinSparklineProps {
  data: number[];
  positive: boolean;
}

const CoinSparklineInner = dynamic(
  () => import('./CoinSparklineInner'),
  { ssr: false, loading: () => <div className="w-16 h-8" /> }
);

export default function CoinSparkline({ data, positive }: CoinSparklineProps) {
  return <CoinSparklineInner data={data} positive={positive} />;
}